import { useEffect } from 'react';
import { useAuth } from './useAuth';
import { hasAuthParams } from './hasAuthParams';
import { auth0Client } from './auth0Client';

export function useLoginRequired() {
  const { login } = useAuth();
  useEffect(() => {
    (async () => {
      if (hasAuthParams()) {
        return;
      }
      const user = await auth0Client.getUser();
      if (!user) {
        await login();
      }
    })();
  }, [login]);
}
